export const SIGN_OUT = { type: 'signout' } as const;
